import { useEffect, useState } from "react";
import BodyHeader from "../../../components/common/CommonBodyHeader";
import CustomTable from "../../../components/common/CustomTable";
import { handlevehicleShortageSummaryMasterList } from "../../../Api/api";
import { useDispatch, useSelector } from "react-redux";

import { backdropLoadingAction } from "../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import * as XLSX from "xlsx";
import { useBoolean } from "../../../Hooks/useBoolean";
import { Stack } from "@mui/material";
import DownloadReportButton from "../../../components/common/DownloadReportButton";
import { vehicleShortageSummaryMasterAsync } from "../../../redux/features/report-master/vehicleShortageSummaryReportMasterSlice";
import { reportDropDownRecordAsync } from "../../../redux/features/report-master/reportDropDownRecordSlice";

import { useFormik } from "formik";
import CustomDropdown from "../../../components/common/CustomDropdown/CustomDropdown";
import CustomInput from "../../../components/common/CustomInput/CustomInput";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { BsFillEyeFill } from "react-icons/bs";

export default function VehicleShortageSummaryReport() {
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const [records, setRecords] = useState([]);

   const reportMasterList = useSelector(
      (state) => state.vehicleShortageSummaryReportMasterSlice.data,
   );

   const columns = [
      {
         name: "Vehicle No.",
         selector: (row) => row?.vehicle_no,
         sortable: true,
      },
      {
         name: "Company Name",
         selector: (row) => row?.company_name,
         sortable: true,
      },
      {
         name: "Customer",
         selector: (row) => row?.customer,
         sortable: true,
      },
      {
         name: "Manager Name",
         selector: (row) => row?.manager_name,
         sortable: true,
      },
      {
         name: "Invoice",
         selector: (row) => row?.invoice_no,
         sortable: true,
      },

      {
         name: "Loading Date",
         selector: (row) =>
            row?.loading_date
               ? moment(row.loading_date).format("DD-MM-YYYY HH:mm:ss")
               : "",
         sortable: true,
      },

      {
         name: "Shortage Deficit",
         selector: (row) => row?.shortage,
         sortable: true,
      },
      {
         name: "Action",
         selector: (row) => (
            <button
               className="btn"
               onClick={() => navigate("/trip/contractual/edit/" + row.tripid)}
            >
               <BsFillEyeFill
                  className="text-primary"
                  style={{ height: "1.5rem", width: "1.5rem" }}
               />
            </button>
         ),
         width: "120px",
         center: true,
      },
   ];

   /// fetching filter drop down values
   const dropDownMaster = useSelector((state) => state.reportDropDownRecordSlice);

   const companyData = [
      { label: "Select..", value: "" },
      ...(dropDownMaster?.data?.company_list?.map?.((item) => ({
         label: item?.company_name,
         value: item?.id,
      })) || []),
   ];

   const fleetData = [
      { label: "Select..", value: "" },
      ...(dropDownMaster?.data?.vehicle_list?.map?.((item) => ({
         label: item?.vehicle_no,
         value: item?.id,
      })) || []),
   ];

   const customerData = [
      { label: "Select..", value: "" },
      ...(dropDownMaster?.data?.customer_list?.map?.((item) => ({
         label: item?.name,
         value: item?.id,
      })) || []),
   ];

   const formik = useFormik({
      initialValues: {
         company: "",
         fleet: "",
         customer: "",
         loadingDateFrom: "",
         loadingDateTo: "",
      },
   });

   const {
      errors,
      values,
      touched,
      getFieldProps,
      handleSubmit,
      setFieldValue,
      resetForm,
   } = formik;

   const reportPopup = useBoolean();

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         reportDropDownRecordAsync({
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   }, []);

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      const filter_params = {};
      if (values.customer) filter_params.customer_id = values.customer;
      if (values.company) filter_params.company_id = values.company;
      if (values.fleet) filter_params.vehicle_id = values.fleet;
      if (values.loadingDateFrom)
         filter_params.loading_date_from = values.loadingDateFrom;
      if (values.loadingDateTo) filter_params.loading_date_to = values.loadingDateTo;

      dispatch(
         vehicleShortageSummaryMasterAsync({
            data: filter_params,
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   }, [
      values.customer,
      values.company,
      values.fleet,
      values.loadingDateFrom,
      values.loadingDateTo,
   ]);

   useEffect(() => {
      if (reportMasterList) {
         const transformedRecords = Object.values(reportMasterList);

         const sortedRecords = transformedRecords.sort((a, b) => {
            let comp = a.company_name?.localeCompare(b.company_name);
            if (comp !== 0) return comp;

            comp = a.vehicle_no?.localeCompare(b.vehicle_no);
            if (comp !== 0) return comp;

            comp = a.customer?.localeCompare(b.customer);
            if (comp !== 0) return comp;

            return 0; // if all same
         });

         setRecords(sortedRecords);
      }
   }, [reportMasterList]);

   // const handleDownloadReport = (data) => {
   //    dispatch(backdropLoadingAction(true));

   //    const filter_params = { data: data };
   //    if (values.customer) filter_params.customer_id = values.customer;
   //    if (values.company) filter_params.company_id = values.company;
   //    if (values.fleet) filter_params.vehicle_id = values.fleet;

   //    dispatch(
   //       vehicleShortageSummaryMasterAsync({
   //          data: filter_params,
   //          err: () => {
   //             dispatch(backdropLoadingAction(false));
   //          },
   //          done: (report_list) => {

   //             const sortedList = Object.values(report_list).sort((a, b) => {
   //                let comp = a.company_name?.localeCompare(b.company_name);
   //                if (comp !== 0) return comp;

   //                comp = a.vehicle_no?.localeCompare(b.vehicle_no);
   //                if (comp !== 0) return comp;

   //                comp = a.customer?.localeCompare(b.customer);
   //                if (comp !== 0) return comp;

   //                return 0;
   //             });

   //             const headers = [
   //                "S. No.",
   //                "Vehicle Number",
   //                "Attached Location",
   //                "Company name",
   //                "Customer",
   //                "Driver Name",
   //                "Shipment or Challan no",
   //                "Loading Date",
   //                "Product Type",
   //                "Shortage Qty",
   //                "QTY",
   //             ];

   //             const emiArr = [];
   //             let totalQty = 0;
   //             let totalShortage = 0;

   //             sortedList.forEach((item, index) => {
   //                const qtyValue = parseFloat(item?.qty) || 0;
   //                totalQty += qtyValue;
   //                totalShortage += parseFloat(item?.shortage) || 0;

   //                emiArr.push([
   //                   index + 1,
   //                   item?.vehicle_no ?? "-",
   //                   item?.attached_location ?? "-",
   //                   item?.company_name ?? "-",
   //                   item?.customer ?? "-",
   //                   item?.driver_name ?? "-",
   //                   item?.invoice_no ?? "-",
   //                   item?.loading_date
   //                      ? moment(item.loading_date).format("DD-MM-YYYY HH:mm:ss")
   //                      : "-",
   //                   item?.product_type ?? "-",
   //                   item?.shortage ?? "-",
   //                   item?.qty ? item.qty + " KL" : "-",
   //                ]);
   //             });

   //             // Footer Row
   //             emiArr.push([
   //                "",
   //                "",
   //                "",
   //                "",
   //                "",
   //                "",
   //                "",
   //                "",
   //                "Total",
   //                totalShortage.toFixed(2),
   //                totalQty.toFixed(2) + " KL",
   //             ]);

   //             const sheetData = [headers, ...emiArr];
   //             const ws = XLSX.utils.aoa_to_sheet(sheetData);
   //             const wb = XLSX.utils.book_new();
   //             XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

   //             XLSX.writeFile(wb, "VEHICLE_SHORTAGE_SUMMAREPORT.xlsx");

   //             dispatch(backdropLoadingAction(false));
   //             reportPopup.onFalse();
   //          },
   //       })
   //    );
   // };

   const handleDownloadReport = async (data) => {
      dispatch(backdropLoadingAction(true));

      const filter_params = { data: data };
      if (values.customer) filter_params.customer_id = values.customer;
      if (values.company) filter_params.company_id = values.company;
      if (values.fleet) filter_params.vehicle_id = values.fleet;
      if (values.loadingDateFrom)
         filter_params.loading_date_from = values.loadingDateFrom;
      if (values.loadingDateTo) filter_params.loading_date_to = values.loadingDateTo;

      try {
         const { data: response } =
            await handlevehicleShortageSummaryMasterList(filter_params);
         if (response.statusCode !== 200) throw new Error(response.message || "Failed");
         const report_list = response.res;
         {
            const sortedList = Object.values(report_list).sort((a, b) => {
               let comp = a.company_name?.localeCompare(b.company_name);
               if (comp !== 0) return comp;

               comp = a.vehicle_no?.localeCompare(b.vehicle_no);
               if (comp !== 0) return comp;

               comp = a.customer?.localeCompare(b.customer);
               if (comp !== 0) return comp;

               return 0;
            });

            // 👉 GROUP BY COMPANY NAME (you can change key)
            const groupKey = "company_name";

            const groups = {};
            sortedList.forEach((item) => {
               const key = item[groupKey] || "Unknown";

               if (!groups[key]) {
                  groups[key] = {
                     items: [],
                     totalQty: 0,
                     totalShortage: 0,
                  };
               }

               const qty = parseFloat(item.qty) || 0;
               const shortage = parseFloat(item.shortage) || 0;

               groups[key].items.push(item);
               groups[key].totalQty += qty;
               groups[key].totalShortage += shortage;
            });

            const headers = [
               "S. No.",
               "Vehicle Number",
               "Attached Location",
               "Company Name",
               "Customer",
               "Driver Name",
               "Shipment or Challan no",
               "Loading Date",
               "Product Type",
               "Shortage Deficit",
            ];

            const sheetRows = [];
            let grandTotalQty = 0;
            let grandTotalShortage = 0;

            // 👉 Convert groups → Excel rows
            Object.keys(groups).forEach((groupName) => {
               const group = groups[groupName];

               group.items.forEach((item, index) => {
                  sheetRows.push([
                     index + 1,
                     item.vehicle_no ?? "-",
                     item.attached_location ?? "-",
                     item.company_name ?? "-",
                     item.customer ?? "-",
                     item.driver_name ?? "-",
                     item.invoice_no ?? "-",
                     item.loading_date
                        ? moment(item.loading_date).format("DD-MM-YYYY HH:mm:ss")
                        : "-",
                     item.product_type ?? "-",
                     item.shortage ?? "-",
                  ]);
               });

               // Group Total Row
               sheetRows.push([
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  `Total`,
                  group.totalShortage.toFixed(2),
               ]);

               // Add to grand total
               grandTotalQty += group.totalQty;
               grandTotalShortage += group.totalShortage;

               // Blank row separator
               sheetRows.push(["", "", "", "", "", "", "", "", "", "", ""]);
            });

            // 👉 Grand Total Footer Row
            sheetRows.push([
               "",
               "",
               "",
               "",
               "",
               "",
               "",
               "",
               "GRAND TOTAL",
               grandTotalShortage.toFixed(2),
            ]);

            const sheetData = [headers, ...sheetRows];

            const ws = XLSX.utils.aoa_to_sheet(sheetData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

            XLSX.writeFile(wb, "VEHICLE_SHORTAGE_SUMMARY_REPORT.xlsx");

            dispatch(backdropLoadingAction(false));
            reportPopup.onFalse();
         }
      } catch (error) {
         dispatch(backdropLoadingAction(false));
         //toast.error(error.message || "Download failed");
      }
   };

   return (
      <div>
         <BodyHeader title="Vehicle Shortage Summary Report" />
         <div className="px-3">
            <div className="row align-items-center">
               <div className="col-lg-2">
                  <CustomDropdown
                     label="Vehicle Number"
                     optionData={fleetData}
                     value={
                        fleetData.find((option) => option.value === values.fleet) ||
                        fleetData[0]
                     }
                     onChange={(value) => {
                        const val = Array.isArray(value) ? value[0]?.value : value?.value;
                        setFieldValue("fleet", val || "");
                     }}
                  />
               </div>
               <div className="col-lg-2">
                  <CustomDropdown
                     label="Company"
                     optionData={companyData}
                     value={
                        companyData.find((option) => option.value === values.company) ||
                        companyData[0]
                     }
                     onChange={(value) => {
                        const val = Array.isArray(value) ? value[0]?.value : value?.value;
                        setFieldValue("company", val || "");
                     }}
                  />
               </div>
               <div className="col-lg-2">
                  <CustomDropdown
                     label="Customer"
                     optionData={customerData}
                     value={
                        customerData.find((option) => option.value === values.customer) ||
                        customerData[0]
                     }
                     onChange={(value) => {
                        const val = Array.isArray(value) ? value[0]?.value : value?.value;
                        setFieldValue("customer", val || "");
                     }}
                  />
               </div>
               <div className="col-lg-2">
                  <CustomInput
                     label="Loading Date From"
                     inputType="date"
                     placeholder="From"
                     {...getFieldProps("loadingDateFrom")}
                  />
               </div>
               <div className="col-lg-2">
                  <CustomInput
                     label="Loading Date To"
                     inputType="date"
                     placeholder="To"
                     {...getFieldProps("loadingDateTo")}
                  />
               </div>
               <div className="col-lg-2">
                  <button
                     type="button"
                     className="btn btn-outline-secondary w-100 mt-4"
                     onClick={() => resetForm()}
                  >
                     Clear Filters
                  </button>
               </div>
               <div className="col-lg-2 pt-2 mt-2 mb-2 text-right">
                  <DownloadReportButton
                     title="Download Report"
                     onDownloadReport={handleDownloadReport}
                     confirmPopup={reportPopup}
                     modal_title="Select Loading Date"
                  />
               </div>
            </div>
            <CustomTable columns={columns} data={records} />
         </div>
      </div>
   );
}
